
 <app-loader *ngIf="!showData"></app-loader>
 <div *ngIf="showData">
    <div class="ui-g">
        <div style="display: inline-block; margin-bottom: 10px; margin-right: 10px;">
           <p-calendar placeholder="{{ 'date_from' | translate }}"[(ngModel)]="dateStart" showTime="true" hourFormat="24" dateFormat="yy-mm-dd" [showIcon]="true"></p-calendar>
        </div>
        <div style="display: inline-block; margin-bottom: 10px; margin-right: 10px;">
           <p-calendar placeholder="{{ 'date_to' | translate }}" [(ngModel)]="dateEnd" showTime="true" hourFormat="24" dateFormat="yy-mm-dd" [showIcon]="true"></p-calendar>
       </div>
       <div style="display: inline-block; margin-bottom: 10px; margin-right: 10px;">
           <button type="button" pButton icon="pi pi-sliders-h" (click)="onToggleFilters()" style="min-width: 60px; margin-left: 10px;"></button>
           <button type="button" pButton icon="pi pi-search" (click)="onSearch()" style="min-width: 60px; margin-left: 10px;"></button>
       </div>
    </div>
   
    <div class="ui-g" *ngIf="showFilters">
        <div style="width: 100%; border-radius: 6px; background: #f4f4f4; margin-bottom: 12px; padding: 8px;">
           <div>
               <button type="button" pButton (click)="onSelectAllFilters()" style="margin: 2px;" label="Zaznacz wszystkie"></button>
               <button type="button" pButton (click)="onDeselectAllFilters()" style="margin: 2px;" label="Odznacz wszystkie"></button>
           </div>
           <div class="ui-g">
               <div class="ui-sm-12 ui-md-6 ui-lg-6 ui-xl-4" *ngFor="let option of filters">
                   <p-checkbox name="filters" value="{{ option.code }}" inputId="{{ option.code }}" [(ngModel)]="selectedFilters" label="{{ option.translate_key | translate }}"></p-checkbox>
               </div>
           </div>       
       </div>
    </div>
   
   <p-table #tt *ngIf="showData"
   [value]="userAuditHistoryPreparedData" 
   [loading]="loading"
   [paginator]="true" 
   [rowsPerPageOptions]="[10,25,50]"
   (onLazyLoad)="onLoadUserAuditHistoryLazy($event)"
   [rows]="rowsOnPage" 
   [lazy]="true"
   [(first)]="first"
   [totalRecords]="totalRecords"
   styleClass="ui-table">
       <ng-template pTemplate="header">
           <tr class="table-header">
               <th>{{ 'date' | translate }}</th>
               <th>
                   {{ 'description' | translate }}
                   <button type="button" pButton icon="pi pi-refresh" (click)="onRefreshSearch()" style="float: right;"></button>
               </th>  
           </tr>          
       </ng-template>  
       <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="2" style="text-align: center;">
                {{ 'no_data' | translate }}
            </td>        
        </tr>
        </ng-template>
       <ng-template  pTemplate="body" let-audit>     
           <tr>
               <td>{{audit.date}}</td>
               <td>{{audit.desc}}</td>
           </tr>
       </ng-template>
   </p-table>
 </div>
 